<template>
  <div class="mb-4" @click="carouselClick">
    <b-carousel
      id="carousel-1"
      :interval="5000"
      :indicators="sliders.length > 1"
      :controls="sliders.length > 1"
      background="#ababab"
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333"
      
    >
      <!-- Text slides with image -->
      <b-carousel-slide
        v-for="(slider, i) in sliders"
        :key="`slider-${i}`"
        :caption="slider.caption"
        :text="slider.text"
        :img-src="slider.src"
        class="click"
      >
        <router-link class="btn btn-outline-light px-5" v-if="slider.to" :to="getLink(slider.to)">VER</router-link>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  props: ["sliders"],
  methods: {
    carouselClick(ev) {
      console.log(ev)
    }
  }
};
</script>